export enum LEVELS_TYPES {
  Shame = 'Shame',
  Guilt = 'Guilt',
  Apathy = 'Apathy',
  Grief = 'Grief',
  Fear = 'Fear',
  Desire = 'Desire',
  Anger = 'Anger',
  Pride = 'Pride',
  Courage = 'Courage',
  Neutrality = 'Neutrality',
  Willingness = 'Willingness',
  Acceptance = 'Acceptance',
  Reason = 'Reason',
  Love = 'Love',
  Joy = 'Joy',
  Peace = 'Peace',
  Enlightenment = 'Enlightenment',
};
